import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from 'store'

type IpRestrictedState = {
  show: boolean
}

const initialState: IpRestrictedState = {
  show: false,
}

export const ipRestrictedSlice = createSlice({
  name: 'ipRestricted',
  initialState,
  reducers: {
    open: state => {
      state.show = true
    },
    close: state => {
      state.show = false
    },
  },
})

export const { open, close } = ipRestrictedSlice.actions

export const selectIpRestrictedStatus = (state: RootState) => ({ ...state.ipRestricted })

export default ipRestrictedSlice.reducer
